module.exports = __webpack_public_path__ + "img/166.3fc8e0ef.jpg";